import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=ec73b950&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=ec73b950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec73b950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec73b950')) {
      api.createRecord('ec73b950', component.options)
    } else {
      api.reload('ec73b950', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=ec73b950&scoped=true&", function () {
      api.rerender('ec73b950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fh6gBCI58yCo/JS/comp/Voucher.vue"
export default component.exports